import { useRef, useEffect, ReactNode } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { usePDFifyStore } from './state'
import { cn } from '@/utils'

export const PDFify = ({
  id,
  order,
  children,
}: {
  id: string
  order: number
  children: ReactNode
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const isGenerating = usePDFifyStore((state) => state.isGenerating)
  const addPageRef = usePDFifyStore(useShallow((state) => state.addPageRef))
  const removePageRef = usePDFifyStore(
    useShallow((state) => state.removePageRef),
  )

  useEffect(() => {
    if (ref.current) {
      addPageRef(id, order, ref.current)
    }

    return () => {
      removePageRef(id)
    }
  }, [addPageRef, id, order, removePageRef])

  return (
    <div
      className={cn(
        'relative h-full w-full bg-white print:!h-[var(--q20-document-page-height)] print:!w-[var(--q20-document-page-width)] print:origin-top-left print:scale-[var(--q20-print-scale)]',
        {
          'overflow-hidden': isGenerating,
        },
      )}
      ref={ref}
    >
      {children}
    </div>
  )
}
